module.exports = __webpack_public_path__ + "fonts/d450a1f.ttf";